export function LoadingExperience() {
  return (
    <div className="experience-loading" role="status" aria-live="polite">
      <div className="loading-orbit" aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
      <p>Assembling the curiosity engine</p>
    </div>
  );
}

